import { z } from 'zod';

export const cosmicWeatherDateInputSchema = z.object({
  date: z
    .string()
    .optional()
    .transform((val) => (val ? new Date(val) : new Date())),
});

export type CosmicWeatherDateInput = z.infer<typeof cosmicWeatherDateInputSchema>;

export const cosmicWeatherRangeInputSchema = z.object({
  startDate: z.string(),
  endDate: z.string(),
});

export type CosmicWeatherRangeInput = z.infer<typeof cosmicWeatherRangeInputSchema>;
